/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useEffect, useRef, useMemo, useState,
} from 'react';
import inputFormat from 'tools/inputFormat';
import PropTypes from 'prop-types';
import Styles from './index.module.css';

function TextInput({
  fieldColor,
  onChange,
  value,
  placeholder,
  type,
  onBlur,
  dataType,
  preventNumberFormat,
  ...props
}) {
  const inputRef = useRef(null);
  useEffect(() => {
    // eslint-disable-next-line no-new
    // eslint-disable-next-line no-unused-vars
    if (!preventNumberFormat && !Number.isNaN(parseInt(value, 10))) inputFormat(inputRef.current);
  }, []);
  const fieldClass = fieldColor === 'blue' ? Styles.textInput : Styles.textInputWhite;
  return (
    <input
      ref={inputRef}
      type={type}
      value={value}
      className={fieldClass}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      {...props}
    />
  );
}

TextInput.propTypes = {
  fieldColor: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  dataType: PropTypes.string,
  preventNumberFormat: PropTypes.bool,
};

TextInput.defaultProps = {
  fieldColor: 'blue',
  onChange: () => {},
  onBlur: () => {},
  value: '',
  placeholder: '',
  type: 'text',
  dataType: '',
  preventNumberFormat: false,
};

export default TextInput;
